module.exports = __webpack_public_path__ + "static/media/1.80c7a61c.jpg";